<template>
  <zen-one 
  :showuserinfo="false" 
  title=""
  :crumbs="crumbs"
  >
  <z-page
  title="Pengumuman"
  >

  <w-dialog
    v-model="dialog1.show"
    :fullscreen="dialog1.fullscreen"
    :width="dialog1.width"
    :persistent="dialog1.persistent"
    :persistent-no-animation="dialog1.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      {{dialog.title}}
    </template>

    <w-form 
      ref="form" 
      v-model="dialog1.valid"
      @validate="save"
      @success="success"
    >
    <z-input label="Tajuk" v-model="form.title"  />
    <br>
    <div class="mb4" v-if="form.content !== undefined">
      <label class="w-input-label">Kandungan</label>
      
      <!-- Container khas untuk Decoupled Editor -->
      <div class="editor-container">
        <div ref="editorToolbarElement" class="editor-toolbar"></div>
        <ckeditor
          :editor="editor" 
          v-model="form.content" 
          :config="editorConfig"
          @ready="onEditorReady"
        ></ckeditor>
      </div>
    </div>
    
    <z-input type="date" label="Tarikh Mula *" v-model="form.tarikh_mula" :validators="[validators.required]" />
    <z-input type="date" label="Tarikh Tamat *" v-model="form.tarikh_tamat" :validators="[validators.required]" />
    <w-input type="file" :preview="false" accept=" image/*" v-model="files" multiple>Muat Naik Gambar *</w-input>
    <z-input label="Susunan" v-model="form.seq" name="Seq" :validators="[validators.required]" />
    <span style="color: red; font-size: 0.8em;">**Saiz gambar hendaklah 1700 x 1200 piksel**</span>
    <br>
    <template v-if="form.id != 0">
    <z-select :items="lkp_status" label="Status *"  v-model="form.lkp_status_id"  :validators="[validators.required]"/>
    </template>
    </w-form>
        

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog1.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog1.loading"
      :disabled="dialog1.valid === false"
      @click="$refs.form.validate()"
      >
        SIMPAN
      </w-button>
    </template>

    
  </w-dialog>
  

  <z-table
    ref="tbluser"
    title="Pengumuman"
    :headers="table.headers"  
    :items="table.items"
    :meta="table.meta"
    class=""
  >

 
  <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
    
    </template>
    <template #item-cell.image="{ item, label, header, index }">
  <w-flex class="flex justify-center image-box">
    <w-image
        class="d-block"
        :src="item.image"
        width="100"
        height="100"
        style="object-fit: cover; border-radius: 4px;" 
    >
    </w-image> 
  </w-flex>
</template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI

        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2"> fal fa-trash</w-icon>PADAM
        </w-button>
       &nbsp;
       
        
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

import { Ckeditor } from '@ckeditor/ckeditor5-vue';

import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {
  components: {
    ckeditor: Ckeditor
  },
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      
      editor: DecoupledEditor,
      editorConfig: {
          licenseKey: 'GPL', 
          toolbar: {
            items: [
              'heading', '|',
              'bold', 'italic', 'underline', 'strikethrough', '|',
              'bulletedList', 'numberedList', '|', 
              'fontColor', 'fontBackgroundColor', '|',
              'fontSize', 'fontFamily', '|',
              'alignment', '|', 
              'outdent', 'indent', '|',
              'link', 'insertTable', 'blockQuote', '|', 
              'undo', 'redo'
            ],
            shouldNotGroupWhenFull: true
          },
          
          table: {
            contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
          },
        height: '300px',
        fontColor: {
            colors: [
                {
                    color: 'hsl(0, 0%, 0%)',
                    label: 'Black'
                },
                {
                    color: 'hsl(0, 100%, 50%)',
                    label: 'Red'
                },
                {
                    color: 'hsl(120, 100%, 25%)',
                    label: 'Green'
                },
                {
                    color: 'hsl(240, 100%, 50%)',
                    label: 'Blue'
                }
            ]
        }
      },

      resourceurl: 'administration.pengumuman',
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Pengumuman', route: '/administration/pengumuman' }
      ],
      
      form: {
        id: 0,
        title: '',
        content: '', 
        lkp_status_id :'',
        tarikh_mula:'',
        tarikh_tamat:'',
        seq:'',
      },
      files: [],
      lkp_status: [],
      dialog1: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1200,
          item: {name: '', email: '', mobile: ''}
        },
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      },
    }
  },
  methods: {
    // Tambahan method untuk Decoupled Editor
    onEditorReady( editor ) {
        // Pindahkan toolbar ke dalam div yang kita sediakan
        if (this.$refs.editorToolbarElement) {
            this.$refs.editorToolbarElement.appendChild( editor.ui.view.toolbar.element );
            // Sembunyikan tapak asal toolbar jika ada (biasanya decoupled tidak letak kat sana, tapi untuk safety)
            editor.ui.view.toolbar.element.style.display = 'none'; 
            // Kemudian paparkan semula di tempat baru
            editor.ui.view.toolbar.element.style.display = 'flex';
        }
    },
   getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_pengumuman', {}).then(res => {
        this.lkp_status = res
      })
    },
    add(){
          this.form = {
              id : 0,
              title : null,
              content : '', 
              lkp_status_id : '',
              tarikh_mula:'',
              tarikh_tamat:'',
              seq:'',
          }
          this.getStatus();
          this.dialog1.show = true
          this.dialog.title = 'TAMBAH'
          this.form.saveButton = "Save"
      },
      save() {
          this.dialog1.loading = true

          if (this.form.id > 0) {
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                  .then(res => {
                     if(this.files.length > 0){
                      this.uploadImg(this.form.id);
                     }
                      this.mapreturneddata(res)
                      this.dialog1.show = false;
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                      this.$inertia.visit(this.$page.url)
                  })
                  .catch(err => {})
                  .finally(() => {
                      this.dialog1.loading = false
                  });
          }
          else {
              this.$zcomm.add(this.resourceurl + '.store', this.form)
                  .then(res => {
                    this.mapreturneddata(res)
                     if(this.files.length > 0){
                        this.uploadImg(res.id);
                     }
                    this.dialog1.show = false;
                    if (typeof this.onAfterAdd === "function") {
                      this.onAfterAdd()
                    }
                    if(this.reload) {
                      this.$inertia.visit(this.$page.url)
                    }
                    this.$inertia.visit(this.$page.url)
                  })
                  .finally(() => {
                      this.dialog1.loading = false;
                  });
          }
        },
        uploadImg(item) 
        {  
           let formData = new FormData();
           for (var b in this.files) 
           {
               formData.append("files["+b+"]", this.files[b].file);
           }
           formData.append("model",'App\\Models\\Pengumuman');
           formData.append("model_id", item);
           this.$zcomm.post('attahecment.upload_replace', formData)
               .then((res) => {
                   this.getAttahecment();
               })
               .catch((err) => {})
               .finally(() => {});
       },
      edit(form){
          this.form = form
          if(!this.form.content) this.form.content = '';
          
          this.dialog1.show = true
          this.getStatus();
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
      }

  },

  watch: {

  },
  mounted() {
    this.dialog.width = 500
  },
}
</script>

<style scoped>

.editor-container {
    border: 1px solid #ddd;
    border-radius: 4px;
}


.editor-toolbar {
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background-color: #fcfcfc;
}


.image-box {
  border: 1px solid #e0e0e0;      
  border-radius: 8px;             
  padding: 5px;                   
  background-color: #ffffff;      
  box-shadow: 0 2px 4px rgba(0,0,0,0.05); 
  display: inline-flex;           
  align-items: center;
  justify-content: center;
}



:deep(.ck-editor__editable) {
    min-height: 250px;  
    max-height: 270px;  
    overflow-y: auto; 
    
    padding: 10px;
}
</style>